<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <v-card color="#98B38F" elevation="0" height="150px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-file-edit-outline</v-icon>
                    &nbsp;T2202A
                </v-card-title>
            </v-card>
            <v-card-text>
                <Manager />
            </v-card-text>
        </v-card>
        <iframe name="hiddenFrame" hidden></iframe>
    </div>
</template>
<script>
import Manager from "../../../components/Admin/T2202A/Manager.vue"
export default {
    components: {
        Manager
    }
}
</script>